var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("rect",{"x":"1","y":"3","width":"20","height":"2","key":1}),React.createElement("rect",{"x":"1","y":"15","width":"20","height":"2","key":2}),React.createElement("rect",{"x":"1","y":"9","width":"20","height":"2","key":3})]);
}

Menu.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18"};

module.exports = Menu;

Menu.default = Menu;
